import { CostTypeCategoryBase } from './base/cost-type-category-base';

export class CostTypeCategory extends CostTypeCategoryBase { }